import React, { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import Input from '~components/Input';
import DateInputWithCalendarIcon from '~components/DateInputWithCalendarIcon';
import useContactForm, {
  ContactFormFieldNames,
} from '~utils/hooks/useContactForm';
import { TransparentButton } from '~apartments/components/styledComponents/buttons';
import {
  StyledRadio,
  Title,
  Description,
  Form,
  FormFieldWrapper,
  RadioLabelText,
  RadioWrapper,
  SubmitSuccessMessage,
} from './styledComponents';

export type Props = {
  titleElem: React.ReactNode;
  descriptionElem: React.ReactNode;
  fieldNames: ContactFormFieldNames[];
  postFn: (data: Record<ContactFormFieldNames, string>) => Promise<unknown>;
  sumbitSuccessElem?: React.ReactNode;
  buttonText?: string;
  afterSubmit?: () => void;
};

const ContactForm = ({
  fieldNames,
  titleElem,
  descriptionElem,
  afterSubmit,
  postFn,
  buttonText = 'Отправить',
  sumbitSuccessElem = (
    <SubmitSuccessMessage>Ваше сообщение отправлено.</SubmitSuccessMessage>
  ),
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);

  const {
    form: { formData, isFormValid },
    inputProps,
  } = useContactForm({
    fieldNames,
  });

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setIsLoading(true);

    postFn(formData).then(() => {
      unstable_batchedUpdates(() => {
        setIsLoading(false);
        setIsSubmitSuccessful(true);

        if (afterSubmit) {
          afterSubmit();
        }
      });
    });
  };

  const showSubmitSuccessElem = isSubmitSuccessful && !!sumbitSuccessElem;

  return (
    <div>
      {showSubmitSuccessElem ? (
        sumbitSuccessElem
      ) : (
        <>
          <Title>{titleElem}</Title>
          <Description>{descriptionElem}</Description>
          <Form onSubmit={onSubmit}>
            {inputProps.map((props) => {
              if (props.name === 'date') {
                return (
                  <FormFieldWrapper key={props.name}>
                    <DateInputWithCalendarIcon
                      name={props.name}
                      value={props.value}
                      placeholderText='Дата просмотра'
                      onBlur={() => props.onBlur(props.name, props.value)}
                      onChange={(val) => props.onChange(props.name, val)}
                      hasError={props.hasError}
                    />
                  </FormFieldWrapper>
                );
              }

              return (
                <FormFieldWrapper key={props.name}>
                  <Input {...props} />
                </FormFieldWrapper>
              );
            })}
            <FormFieldWrapper>
              <RadioWrapper>
                <StyledRadio checked color='white'>
                  <RadioLabelText>
                    Я согласен на обработку персональных данных
                  </RadioLabelText>
                </StyledRadio>
              </RadioWrapper>
            </FormFieldWrapper>
            <FormFieldWrapper>
              <TransparentButton
                type='submit'
                borderRadius='rounded'
                disabled={!isFormValid() || isLoading}
              >
                {buttonText}
              </TransparentButton>
            </FormFieldWrapper>
          </Form>
        </>
      )}
    </div>
  );
};

export default ContactForm;
